import React from "react";

type Props = {
  id?: string;
  disabled?: boolean;
  fetching?: boolean;
  hero?: boolean;
  text: string;
  onClick: $TSFixMeFunction;
  mobileIcon?: string;
};

function Button({
  id,
  text,
  disabled,
  fetching,
  mobileIcon,
  onClick,
  hero,
}: Props) {
  const spinner = fetching ? <i className="btn-spinner" /> : null;
  const icon = mobileIcon && !fetching ? <i className={mobileIcon} /> : null;
  let className = "btn btn-default";
  if (hero) {
    className = mobileIcon
      ? "btn btn-primary btn-mobile-icon"
      : "btn btn-primary";
  } else {
    className = mobileIcon
      ? "btn btn-default btn-mobile-icon"
      : "btn btn-default";
  }

  const buttonRef = React.useRef();

  const hanldeOnClick = () => {
    onClick();
    // @ts-expect-error TS(2532) FIXME: Object is possibly 'undefined'.
    buttonRef.current.blur();
  };

  return (
    <button
      id={id}
      // @ts-expect-error TS(2322) FIXME: Type 'MutableRefObject<undefined>' is not assignab... Remove this comment to see the full error message
      ref={buttonRef}
      name="submit"
      onClick={() => hanldeOnClick()}
      className={className}
      disabled={disabled || fetching}
      type="button"
    >
      <span className="btn-icon">{icon}</span>
      <span className="btn-text">{text}</span>
      {spinner}
    </button>
  );
}

export default Button;
